<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{ initdata.title }}</span>
      <div slot="content">
        <!-- 全选 -->
        <section class="sort-item" v-if="initdata.showSelectAll">
          <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll"
            >全选</Checkbox
          >
          <span class="sort-number">{{ totalNumber }}</span>
        </section>
        <!-- 复选框组 on-change 类似于watch-->
        <CheckboxGroup v-model="dataList" @on-change="comChange">
          <drop
            class="sort-item"
            v-for="(item, index) in initdata.dataList"
            :data-index="index"
            :key="item.label"
            @eldrop="eldrop"
            :el-index="index"
          >
            <!-- 复选框 -->
            <Checkbox :label="index" class="sort-checkbox">
              <span class="sort-label">{{ item.label }}</span>
            </Checkbox>
            <!-- 复选框人数 -->
            <span class="sort-number">{{ item.number }}</span>
          </drop>
        </CheckboxGroup>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
import drop from "../dragger/drop";
export default {
  created() {
    this.comChange = this._.debounce(this._comChange, this.debounceTime);
  },
  mounted() {},
  props: ["initdata", "filterListIndex", "debounceTime"],
  data() {
    return {
      dataList: []
    };
  },
  computed: {
    totalNumber() {
      return this.initdata.dataList.reduce((pre, cur) => pre + cur.number, 0);
    },
    // 全选组件是否 半选中（有选中但未全选中）
    indeterminate() {
      return (
        this.dataList.length > 0 &&
        this.dataList.length !== this.initdata.dataList.length
      );
    },
    // 全选组件是否 全选中
    checkAll: {
      get() {
        return this.dataList.length === this.initdata.dataList.length;
      },
      set(val) {
        this.dataList = val
          ? this.initdata.dataList.map((item, index) => index)
          : [];

        this._comChange();
      }
    }
  },
  watch: {
    "initdata.checkAll": {
      handler(val) {
        if (this._.isBoolean(val)) this.checkAll = val;
      },
      immediate: true
    }
  },
  methods: {
    handleCheckAll() {
      // 1. 如果半选中 点击取消全选
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        // 2. 如果不是半选中状态 点击 执行选中相反的结果
        this.checkAll = !this.checkAll;
      }
    },
    /* 复选组勾选装填改变 */
    _comChange() {
      this.$emit("event", {
        fn: "comChange",
        params: {
          selectedIndex: this.dataList,
          filterListIndex: this.filterListIndex
        }
      });
    },
    eldrop(e) {
      this.$emit("event", {
        fn: "comDrop",
        params: {
          filterListIndex: this.filterListIndex,
          ...e
        }
      });
    },
    reset() {
      this.dataList = [];
      this.$emit("event", {
        fn: "reset"
      });
    }
  },
  components: { drop }
};
</script>
<style scoped lang="less">
@import "./collapse.less";
</style>
